import React from 'react'
import AcademicsRoutes from './Academics/Academics.routes'
import { Route } from 'react-router-dom'
import ResidentialRoutes from './Residential/Residential.routes'
import WorkshopRoutes from './Workshop/Workshop.routes'

const OperationalRoutes =
    <Route path="operational/*">
        <Route path='*' element={<div>Not Found</div>} />
        {AcademicsRoutes}
        {ResidentialRoutes}
        {WorkshopRoutes}
    </Route>

export default OperationalRoutes